import styled, { css } from 'styled-components'
import { Box } from './Box'

export interface ScrollBoxProps {
  allowHorizontal?: boolean
  scrollBarMode?: 'Default' | 'Hidden'
}

export const ScrollBox = styled(Box)<ScrollBoxProps>`
  height: 100%;
  overflow-y: auto;
  overflow-x: ${props => (props.allowHorizontal ? 'auto' : 'hidden')};
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 16px;
    ${({ scrollBarMode = 'Default' }) =>
      scrollBarMode === 'Hidden' &&
      css`
        display: none;
      `}
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 1px;
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 1px;
    min-height: 40px;
    background-color: #a5abb6;
    background-clip: padding-box;
    border: 6px solid rgba(0, 0, 0, 0);

    ${({ scrollBarMode = 'Default' }) =>
      scrollBarMode === 'Hidden' &&
      css`
        display: none;
      `}
  }
`
